module.exports = __webpack_public_path__ + "static/img/day9.bb17297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/day9.jpg
// module id = 5mwz
// module chunks = 35